
const isDevEnv = Boolean(process.env.NODE_ENV.toLowerCase() === "development");


const getEnv = isDevEnv ? process.env.REACT_APP_API_LIVE_URL : process.env.REACT_APP_API_LIVE_URL
//  const getEnv = isDevEnv ? process.env.REACT_APP_API_DEV_URL : process.env.REACT_APP_API_DEV_URL
// const getEnv = isDevEnv ? process.env.REACT_APP_API_DEV_URL : process.env.REACT_APP_API_LIVE_URL

export const root = getEnv + 'api/';

export const uri = {
    resetPassword: "/AdminUser/ResetPassword",
};


